module.exports = __webpack_public_path__ + "img/horizontal_4_5_6005.5e15bf4c.png";